/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ChangeTargetNotes$Params {
  targetId?: number;
  newNotes?: string;
  shouldMarkAsNew?: boolean;
}

export function ChangeTargetNotes(http: HttpClient, rootUrl: string, params?: ChangeTargetNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, ChangeTargetNotes.PATH, 'post');
  if (params) {
    rb.query('targetId', params.targetId, {});
    rb.query('newNotes', params.newNotes, {});
    rb.query('shouldMarkAsNew', params.shouldMarkAsNew, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

ChangeTargetNotes.PATH = '/api/Staff/ChangeTargetNotes';
